import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'

const IMAGE_WIDTH = 128

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  border-radius: ${cssTheme.layout.radius.md};
  overflow: hidden;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid;
  border-color: ${cssTheme.colors.border.brand.secondary};
  border-bottom-color: ${cssTheme.colors.border.brand.tertiary};
`

export const HotelName = styled.h2`
  ${cssTheme.typography.titleL}
  margin: ${cssTheme.layout.spacing.s200} 0;
  word-wrap: break-word;
  flex-shrink: 0;
`

export const ReviewRatingWrapper = styled.div`
  padding-top: ${cssTheme.layout.spacing.s300};
  padding-bottom: ${cssTheme.layout.spacing.s100};
`

export const ImageContainer = styled.div`
  width: ${IMAGE_WIDTH}px;
  flex-shrink: 0;
`
export const PlaceholderImageElement = styled.img`
  height: 100%;
  width: ${IMAGE_WIDTH}px;
  object-fit: cover;
  object-position: 20%;
`
